class t extends HTMLElement {
  constructor() {
    super(), this.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 16 16"><g clip-path="url(#a)"><path d="M5.925 3.5c-.284 0-.555.114-.754.313L5 3.984l-.157-.157a1.061 1.061 0 0 0-1.508-.014l-.015.014a1.083 1.083 0 0 0 0 1.538L5 7.059l1.68-1.694a1.083 1.083 0 0 0 0-1.538c-.2-.213-.47-.327-.755-.327Z"></path><path fill-rule="evenodd" d="M2 1.5a1 1 0 0 0-1 1v11a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-11a1 1 0 0 0-1-1H2Zm0 1v5h1.5a.5.5 0 0 1 .46.31L6 12.64 9.778 2.5H2Zm1.165 6 2.087 5H2v-5h1.165Zm8.021-6 1.674 5H14v-5h-2.814Zm1.314 6H14v5H6.725l3.775-10 1.525 4.66a.5.5 0 0 0 .475.34Z" clip-rule="evenodd"></path></g><defs><clipPath id="a"><path d="M0 0h16v16H0z"></path></clipPath></defs></svg>';
  }
}
const e = "pi-mod-health";
customElements.get(e) || customElements.define(e, t);
export {
  t as default
};
